/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type ExactlyValueConfigKind = (typeof ExactlyValueConfigKind)[keyof typeof ExactlyValueConfigKind];

export const ExactlyValueConfigKind = {
  exactly: 'exactly',
} as const;
